<template>
  <topbar
    :titulo="$t('SUPRIMENTOS_LANCAMENTOS_NF.PAGE_TITLE')"
    :subtitulo="$t('SUPRIMENTOS_LANCAMENTOS_NF.PAGE_DESCRIPTION')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div
        class="d-flex flex-md-row flex-column justify-content-between ml-md-4"
      >
        <b-button variant="info" @click="cadastrar" v-if="podeCadastrar">
          {{ $t('GERAL.CADASTRAR') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
<script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('SUPRIMENTOS.SUPRIMENTOS') },
        { titulo: this.$t('SUPRIMENTOS.LANCAMENTOS_NF') },
      ],
    };
  },
  methods: {
    cadastrar() {
      this.$router.push({ name: 'criar-nf' });
    },
  },
};
</script>
